"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var logger_exports = {};
__export(logger_exports, {
  defaultLogger: () => defaultLogger
});
module.exports = __toCommonJS(logger_exports);
const defaultLogger = {
  warn: /* @__PURE__ */ __name((message, meta) => {
    console.warn(`[WARN] ${message}`, meta);
  }, "warn"),
  error: /* @__PURE__ */ __name((message, meta) => {
    console.error(`[ERROR] ${message}`, meta);
  }, "error"),
  info: /* @__PURE__ */ __name((message, meta) => {
    console.info(`[INFO] ${message}`, meta);
  }, "info")
};
//# sourceMappingURL=logger.js.map
